import React from "react";
import { useTranslation } from "react-i18next";
import Popup from "components/popup/Popup";
import {
  EMAIL_BUILDER_AUTOSAVE_CONFLICT_MESSAGE,
  EMAIL_BUILDER_AUTOSAVE_CONFLICT_RELOAD_WARNING,
} from "redux/reducers/emailBuilder/emailBuilderAutosave";

type TEmailBuilderAutosaveConflictModalProps = {
  open: boolean;
  reloading: boolean;
  onReload: () => void;
};

export function EmailBuilderAutosaveConflictModal(
  props: TEmailBuilderAutosaveConflictModalProps,
) {
  const { t } = useTranslation();

  return (
    <Popup
      open={props.open}
      type="warning"
      title={t("Draft conflict")}
      description={`${t(EMAIL_BUILDER_AUTOSAVE_CONFLICT_MESSAGE)} ${t(EMAIL_BUILDER_AUTOSAVE_CONFLICT_RELOAD_WARNING)}`}
      backDropCancel={false}
      okText={props.reloading ? t("Reloading…") : t("Reload")}
      onOk={props.onReload}
      okDisabled={props.reloading}
      loading={props.reloading}
    />
  );
}
